import { INVOICES_CONSTANTS } from 'utils/constants/invoices';
import { currencyHelpers } from 'utils/helpers/currencyHelpers';
import { dateHelpers } from 'utils/helpers/dateHelpers';

import type { THistorySettlement } from 'models/Merchant/HistorySettlement';
import type { TTableColumn } from 'models/Table';

import { Type } from './components/Type';

export const COLUMNS: TTableColumn<THistorySettlement>[] = [
    {
        key: 'merchantName',
        title: 'balance.balanceTable.merchantName',
        dataIndex: 'merchantName',
    },
    {
        key: 'identity',
        title: 'balance.historySettlementsTable.identity',
        dataIndex: 'identity',
    },
    {
        key: 'currency',
        title: 'balance.historySettlementsTable.currency',
        dataIndex: 'currency',
    },
    {
        key: 'type',
        title: 'balance.historySettlementsTable.type',
        dataIndex: 'type',
        render: (_, record) => <Type type={record.type} />,
    },
    {
        key: 'amount',
        title: 'balance.historySettlementsTable.amount',
        dataIndex: 'amount',
    },
    {
        key: 'currencyRate',
        title: 'balance.historySettlementsTable.currencyRate',
        dataIndex: 'currencyRate',
        render: (_, record) =>
            record.currencyRate &&
            currencyHelpers.formatPrecision(1 / Number(record.currencyRate)),
    },
    {
        key: 'amountUsd',
        title: 'balance.historySettlementsTable.amountUsd',
        dataIndex: 'amountUsd',
    },
    {
        key: 'commission',
        title: 'balance.historySettlementsTable.commissionAmount',
        dataIndex: 'commission',
    },
    {
        key: 'createdAt',
        title: 'balance.historySettlementsTable.createdAt',
        dataIndex: 'createdAt',
        render: (_, record) =>
            record.createdAt
                ? dateHelpers.formatTo(
                      record.createdAt,
                      INVOICES_CONSTANTS.VIEW_DATE_FORMAT,
                      undefined,
                      false,
                  )
                : '',
    },
    {
        key: 'comment',
        title: 'balance.historySettlementsTable.comment',
        dataIndex: 'comment',
    },
];
